import React from 'react'
import { Redirect, Route } from 'react-router'
import { dashboardUrl, logoutUrl, opencloudHomeUrl } from 'app/constants'
import store, { RootState } from 'app/store'
import LogoutPage from 'core/public/LogoutPage'
import { preferencesStoreKey } from 'core/session/preferencesReducers'
import { sessionStoreKey } from 'core/session/sessionReducers'
import { isOpenCloud } from 'core/utils/helpers'
import DeveloperToolsEmbed from 'developer/components/DeveloperToolsEmbed'

export const renderPublicPages = () => {
  const state: RootState = store.getState()
  const session = state[sessionStoreKey]
  const { username } = session
  let redirectPath = dashboardUrl

  if (state?.[preferencesStoreKey]?.[username]) {
    const { lastVisitedPath } = state[preferencesStoreKey][username]?.root || {}
    const defaultUrl = isOpenCloud() ? opencloudHomeUrl : dashboardUrl
    redirectPath = lastVisitedPath ? lastVisitedPath : defaultUrl
  }

  return (
    <>
      <Route path={logoutUrl} component={LogoutPage} />
      <Redirect to={redirectPath} />
    </>
  )
}

export const renderDevTools = () => <DeveloperToolsEmbed />
